import React from "react";

export default function HistoricalGamesDisclosure({ children, defaultOpen = true, resetKey = "", style = {}, contentStyle = {} }) {
  const [open, setOpen] = React.useState(defaultOpen);

  React.useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen, resetKey]);

  return (
    <details
      data-testid="historical-games-disclosure"
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
      style={{
        marginTop: 14,
        border: "1px solid #E2E8F0",
        borderRadius: 14,
        background: "#FFFFFF",
        overflow: "hidden",
        ...style,
      }}
    >
      <summary style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "13px 14px", color: "#0F172A", fontWeight: 950, cursor: "pointer", listStyle: "none" }}>
        <span>Historical Games</span>
        <span aria-hidden="true" style={{ color: "#64748B" }}>{open ? "▴" : "▾"}</span>
      </summary>
      <div style={{ padding: "0 14px 14px", ...contentStyle }}>{children}</div>
    </details>
  );
}
